import React, { useEffect } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";

const IWW_IMP_PM_KPI = ({ data, changeValues, filter, showModalCalRange }) => {

    const { setValues, values, calculoPromedio, calculoPeriod, calculoDias } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {

        const datas = {
            performance_indicators: {
                proj_comp_date: calculoDias('actual_proj_comp_date', 'init_proj_comp_date', null, filter.yearInit),
                const_period: calculoPeriod('actual_const_period', 'forecast_const_period', filter.yearInit),
                capex: calculoPeriod('actual_capex', 'forecast_capex', filter.yearInit),
                opex: calculoPeriod('actual_opex', 'forecast_opex', filter.yearInit),
                maint_cost: calculoPeriod('actual_maint_cost', 'forecast_maint_cost', filter.yearInit),
                interest_during_const: calculoPromedio('interest_during_const', filter.yearInit),
                ebitda: calculoPeriod('actual_ebitda', 'forecast_ebitda', filter.yearInit),                
                revenue: calculoPeriod('actual_revenue', 'forecast_revenue', filter.yearInit),
                traffic_dev: {
                    train_traffic: calculoPeriod('actual_train_traffic', 'forecast_train_traffic', filter.yearInit),
                    pass_traffic: calculoPeriod('actual_pass_traffic', 'forecast_pass_traffic', filter.yearInit),
                    freight_tn: calculoPeriod('actual_freight_tn', 'forecast_freight_tn', filter.yearInit)
                }
            }
        }

        changeValues(datas)
    }

    return (
        <Tabs defaultActiveKey="performance_indicators" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="performance_indicators" title="Performance Indicators" className={style.tabHeight} style={{ height: "71vh" }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performanceInd.projectTimeDev.proj_comp_date" label="Completion date deviation (no. of months)" name="performanceInd.projectTimeDev.proj_comp_date" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.const_period" label="Construction duration deviation (%)" name="performance_indicators.const_period" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.capex" label="CAPEX deviation (%)" name="performance_indicators.capex" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.opex" label="OPEX deviation (%)" name="performance_indicators.opex" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.maint_cost" label="Maintenance cost deviation (%)" name="performance_indicators.maint_cost" disabled={true} />
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="performance_indicators.ebitda" label="EBITDA – last year (% of projects within user-defined ranges)" name="performance_indicators.ebitda" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("performance_indicators.ebitda", "ebitda")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.revenue" label="Revenue deviation - if fare/toll collected (%)" name="performance_indicators.revenue" disabled={true} />
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Traffic</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.train_traffic" label="Traffic deviation (%)" name="performance_indicators.traffic_dev.train_traffic" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.pass_traffic" label="Passenger traffic deviation (%)" name="performance_indicators.traffic_dev.pass_traffic" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.freight_tn" label="Freight (tn) deviation (%)" name="performance_indicators.traffic_dev.freight_tn" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default IWW_IMP_PM_KPI;